import LazyDisp from "../class/lazydisp";
import GET_ARTICLES from "../class/getArticles";
import TAGSORT, {related} from "../class/tagsort";

const [ w, d, mq ] = [window, document, window.matchMedia( "(max-width: 900px)" ) ];

const domReady = TPL => {

  //requirement
  const requirement_block = new GET_ARTICLES('.recruit-requirement__list[data-plugin="getArticles"]');
  requirement_block.makeItem = (item,content) => `
    <a href="${item.href}" class="recruit-requirement__item">
      <div class="recruit-requirement__item-img"><img src="${item.thumb}" alt="${item.title}"></div>
      <!-- /.recruit-requirement__item-img -->
      <div class="recruit-requirement__item-body">
        <span class="cat">${item.category.name}</span>
        <span class="subject">${item.title}</span>
        ${item.desc? `<span class="desc">${item.desc.str_truncate(38)}</span>`: ''}
      </div>
      <!-- /.recruit-requirement__item-body -->
    </a>
    <!-- /.recruit-requirement__item -->`;
  // requirement_block.makeItem = (item) => console.log(item);
  requirement_block.render();

  // 関連記事
  const related_guideline = new TAGSORT({
    related: {
      disp_detail: true,
      sortType: 'category', // or category
      amount: 3,
      itemTemplate: `
        <div class="recruit-related-content" v-if="relatedArticles.length">
          <div class="recruit-related-content__inner">
            <!-- /.recruit-related-content__title -->
            <ul class="recruit-related-content__list">
              <li class="recruit-related-item" v-for="( article, ind ) in relatedArticles" :key="article.id" :class="[ 'is-item-' + ind ]">
                <a :href="article.href" class="recruit-related-item__link">
                  <figure class="recruit-related-item__thumb">
                    <img :src="article.thumb" :alt="article.title" width="100%" loading="lazy" class="recruit-related-item__thumb-img">
                    <span class="cate" :class="'is-cat'+article.category.id" :data-href="article.category.href" v-if="article.category">{{ article.category.name }}</span>
                  </figure>
                  <div class="recruit-related-item__body">
                    <h5 class="title">{{ article.title }}</h5>
                  </div><!-- /.recruit-related-item__body -->
                </a>
                <!-- /.recruit-related-item__link -->
              </li>
              <!-- /.recruit-related-item -->
            </ul>
            <!-- /.recruit-related-content__list -->
          </div>
          <!-- /.recruit-related-content__inner -->
        </div>
        <!-- /.recruit-related-content -->
      `
    }
  });

  // relatedの拡張
  class related_custom extends related {
    constructor( opt, parent ) {
      super( opt, parent );
    }
    insertContainer () {
      return false
    } 
  }

  related_guideline.init.then( TAGSORT => {
    related_guideline.related = new related_custom( related_guideline.opt.related, TAGSORT );
    if( related_guideline.is_detail() ) related_guideline.related.render();
  });
};

const onLoadHtml = () => {
  // LazyDisp開始
  new LazyDisp('[data-lazydisp]');
};

export default function RECRUIT () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
  $(() => Promise.all([w.load['loadHtml']]).then( onLoadHtml ) );
  
}